// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"Menu_menu-item__k3BAa"};